export const convertMessageEnToDe = (msg, parameters) => {
  let msgDe = msg;
  for (const p of parameters) {
    msgDe = msgDe.replaceAll(p.key, p.key_label);
  }
  return msgDe;
};

export const convertMessageDeToEn = (msg, parameters) => {
  let msgEn = msg;
  for (const p of parameters) {
    msgEn = msgEn.replaceAll(p.key_label, p.key);
  }
  return msgEn;
};
